import { httpClient, authTokenUtils } from '@/api/httpClient';
import { deviceIdentity } from '@/api/deviceIdentity';
import type {
  AuthSession,
  BackendLoginResponse,
  LoginRequest,
  LoginResponse,
  User
} from '@/types/auth';

export const authApi = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await httpClient<BackendLoginResponse>('/api/v1/auth/login/', {
      method: 'POST',
      body: JSON.stringify({
        ...credentials,
        device_id: credentials.device_id ?? deviceIdentity.getDeviceId(),
        device_name: credentials.device_name ?? deviceIdentity.getDeviceName()
      }),
      skipAuth: true
    });
    const tokens = authTokenUtils.normalizeTokens(response);

    if (!tokens.accessToken || !tokens.refreshToken) {
      throw new Error('Invalid login response');
    }

    return {
      access_token: tokens.accessToken,
      refresh_token: tokens.refreshToken,
      user: response.user
    };
  },
  me() {
    return httpClient<User>('/api/v1/auth/me/');
  },
  logout() {
    const refreshToken = authTokenUtils.tokenStorage.getRefreshToken();

    return httpClient<void>('/api/v1/auth/logout/', {
      method: 'POST',
      body: JSON.stringify({ refresh: refreshToken ?? '' }),
      skipAuth: true,
      skipRefresh: true
    });
  },
  listSessions() {
    return httpClient<AuthSession[]>('/api/v1/auth/sessions/');
  },
  revokeSession(id: string) {
    return httpClient<void>(`/api/v1/auth/sessions/${id}/`, {
      method: 'DELETE'
    });
  },
  revokeAllSessions() {
    return httpClient<void>('/api/v1/auth/sessions/revoke-all/', {
      method: 'POST'
    });
  }
};
